/**
 * @generated SignedSource<<3eda0efbb8f96de29faecb4153fa7f0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleListItem_item$data = {
  readonly __typename: "RoutineOccasion";
  readonly deadlineAt: string | null;
  readonly id: string;
  readonly routine: {
    readonly id: string;
  };
  readonly sequenceNumber: number;
  readonly startAt: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineOccasionListItem_item">;
  readonly " $fragmentType": "WidgetTeamScheduleListItem_item";
} | {
  readonly __typename: "TeamScheduleInlineRoutineOccasion";
  readonly id: string;
  readonly startAt: string;
  readonly taskExecution: {
    readonly routine: {
      readonly id: string;
    } | null;
    readonly routineOccasion: {
      readonly deadlineAt: string | null;
      readonly sequenceNumber: number;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion">;
  readonly " $fragmentType": "WidgetTeamScheduleListItem_item";
} | {
  readonly __typename: "TeamScheduleOneOffEvent";
  readonly endAt: string;
  readonly startAt: string;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarEventItemListItem_eventItem">;
  readonly " $fragmentType": "WidgetTeamScheduleListItem_item";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "WidgetTeamScheduleListItem_item";
};
export type WidgetTeamScheduleListItem_item$key = {
  readonly " $data"?: WidgetTeamScheduleListItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleListItem_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleListItem_item",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskExecutionCheck",
          "kind": "LinkedField",
          "name": "taskExecution",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineOccasion",
              "kind": "LinkedField",
              "name": "routineOccasion",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v5/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion"
        }
      ],
      "type": "TeamScheduleInlineRoutineOccasion",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v5/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleRoutineOccasionListItem_item"
        }
      ],
      "type": "RoutineOccasion",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CalendarEventItemListItem_eventItem"
        },
        (v5/*: any*/)
      ],
      "type": "TeamScheduleOneOffEvent",
      "abstractKey": null
    }
  ],
  "type": "TeamScheduleEventOccasion",
  "abstractKey": "__isTeamScheduleEventOccasion"
};
})();

(node as any).hash = "a6a4b5536649aaf9ba9fd450a7644429";

export default node;
